import { useNavigate } from 'react-router-dom';
import { useCustomLocation } from '.';
import PATH from 'crono-fe-common/constants/path';

interface IProps {
  onRedirect?: () => void;
}

const useRedirectToInbox = ({ onRedirect }: IProps) => {
  const navigate = useNavigate();

  const { setCustomStateLocation } = useCustomLocation();

  const redirectToInbox = (prospectId?: string) => {
    navigate(PATH.INBOX);
    setCustomStateLocation({
      initialProspectIdInbox: prospectId,
    });
    if (onRedirect) {
      onRedirect();
    }
  };
  return redirectToInbox;
};

export default useRedirectToInbox;
